import axios from 'axios';
import { UserState } from '@/store/modules/user/types';

export interface LoginData {
  username: string;
  password: string;
}

export interface KookLoginData {
  code: string;
}

export interface LoginRes {
  token: string;
}
export function login(data: LoginData) {
  return axios.post<LoginRes>('/api/user/login', data);
}

export function kookLogin(params: KookLoginData) {
  return axios.post<LoginRes>('user/dc_login', {
    params,
  });
}

export function getKookUserInfo(token) {
  return axios.post<UserState>('user/dc_user_info', {
    params: { token },
  });
}

export function updateAvatarApi(avatar) {
  return axios.post<any>('/user/update_avatar', {
    params: { avatar },
  });
}

export function logout() {
  // return axios.post<LoginRes>('/api/user/logout');
}

export function getUserInfo() {
  return axios.post<UserState>('/api/user/info');
}
